angular.module('PatientApp').factory('LoyalInjectionService', function($window){

    var service = {

        injectWidget: function(loyalClientId){
            var loyalWidgetScript = $window.document.createElement('script');
            loyalWidgetScript.src = 'https://guide-staging.loyalhealth.com/client/client.bundle.js';
            loyalWidgetScript.setAttribute('data-id', 'guide-client-id');
            loyalWidgetScript.setAttribute('data-value', loyalClientId);
            loyalWidgetScript.async = true;
            $window.document.body.appendChild(loyalWidgetScript);
            
            this.isWidgetInjected = true;
        },

        injectStyle: function(padding, customClassName, disableShadowDOM) {
            var loyalStyleOverrideScript = $window.document.createElement('script');
            loyalStyleOverrideScript.text = 'window.guideSettings = { padding: ' + padding + ', customClassName: \'' + customClassName + '\', disableShadowDOM: ' + disableShadowDOM + '}';
            loyalStyleOverrideScript.id = 'loyal-style-override';
            $window.document.head.appendChild(loyalStyleOverrideScript);

            this.isStyleInjected = true;
        },

        startManualStyleInjection: function(pollingWaitTime, maxRetries, numRetries) {
            if (!numRetries) {
                numRetries = 0;
            }
            var guide = $window.document.querySelector('#guide');
            if (!guide || !guide.shadowRoot || !guide.shadowRoot.querySelector('.loyal-wrapper')) {
                if (maxRetries === numRetries) {
                    return;
                }
                var self = this;
                setTimeout(function() { self.startManualStyleInjection(pollingWaitTime, maxRetries, numRetries + 1); }, pollingWaitTime);
            } else {
                var loyalStyle = $window.document.createElement('style');
                loyalStyle.type = 'text/css';
                /*
                    .loyal-wrapper {
                        left: unset; }
                    @media screen and (min-width: 769px) {
                        .loyal-wrapper {
                            bottom: 50px; left: unset; right: 25px; }
                        div[class^="ChatWindow__ChatWrapper"] {
                            width: 300px !important; }
                    }
                    @media screen and (max-width: 768px) {
                        .loyal-wrapper {
                            bottom: 0px; left: unset; right: 0px; }
                        div[class^="LauncherPortal__LauncherPortalWrapper"] {
                            right: 25px !important; }
                    }
                    div[class^="ChatWindow__ChatWrapper"] {
                        left: unset !important;
                        right: 0px; }
                    div[class^="LauncherPortal__LauncherPortalWrapper"] {
                        left: unset !important;
                        right: 0px; }
                 */
                loyalStyle.appendChild($window.document.createTextNode('.loyal-wrapper { left: unset; } @media screen and (min-width: 769px) {.loyal-wrapper { bottom: 50px; left: unset; right: 25px; } div[class^="ChatWindow__ChatWrapper"] { width: 300px !important; } } @media screen and (max-width: 768px) { .loyal-wrapper { bottom: 0px; left: unset; right: 0px; } div[class^="LauncherPortal__LauncherPortalWrapper"] { right: 25px !important; } } div[class^="ChatWindow__ChatWrapper"] { left: unset !important; right: 0px; } div[class^="LauncherPortal__LauncherPortalWrapper"] { left: unset !important; right: 0px; }'));
                
                guide.shadowRoot.appendChild(loyalStyle);
                guide.setAttribute('style', 'visibility: visible');

                // Pin the chatwrapper to the right side of the screen without allowing overlap
                var chatWrapper = guide.shadowRoot.querySelector('[data-testref="chat-wrapper"]');
                chatWrapper.setAttribute('style', 'position: relative; right: 0');
            }
        },

        isWidgetInjected: false,
        isStyleInjected: false
    };

    return service;
});
